import axios from "axios";
const host = window.location.host;
let instance;
switch (host) {
    case "advantechny.wifikey.io": {
     instance = axios.create({
      baseURL: "https://api.wifikey.link/advantechny",
      });
      break;
    }
     case "anywair.wifikey.io": {
     instance = axios.create({
      baseURL: "https://api.wifikey.link/anywair",
      });
      break;
    }
    case "blueport.wifikey.io": {
     instance = axios.create({
      baseURL: "https://api.wifikey.link/preview",
      });
      break;
    }
    case "comcast.wifikey.io": {
     instance = axios.create({
      baseURL: "https://api.wifikey.link/comcast",
      });
      break;
    }
    case "dishfiber.wifikey.io":
    case "www.mydishfiber.com": {
     instance = axios.create({
      baseURL: "https://api.wifikey.link/preview",
      });
      break;
    }
    case "dish.roamingiqtest.com":
    case "dishfiberlabtesting.roamingiqtest.com": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/v1",
        });
        break;
    }
    case "dish.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/dish",
        });
        break;
    }
    case "getgrooven.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/getgrooven",
        });
        break;
    }
    case "www-test.mydishfiber.com": {
        instance = axios.create({
            baseURL: "https://api-dishfiber.roamingiqtest.com/v1",
        });
        break;
    }
    case "blueport.roamingiqtest.com": {
        instance = axios.create({
            baseURL: "https://api.roamingiqtest.com/v1",
        });
        break;
    }
    case "blueportiq.roamingiqtest.com": {
        instance = axios.create({
            baseURL: "https://api.roamingiqtest.com/v1",
        });
        break;
    }
    case "roamingiq.roamingiqtest.com":
    case "vault.roamingiqtest.com": {
        instance = axios.create({
            baseURL: "https://api.roamingiqtest.com/v1",
        });
        break;
    }
    case "roamingiq.wifikey.io": {
        instance = axios.create({
            baseURL: "https://api.wifikey.io/v1",
        });
        break;
    }
    case "xperity.wifikey.link": {
        instance = axios.create({
            baseURL: "https://apixperity.us-east-1.wifikey.link/xperity",
        });
        break;
    }
    // eslint-disable-next-line
    case "xperity.wifikey.link":
    case "sanket3xperity.wifikey.link":
    case "sanket5xperity.wifikey.link":
    case "xperity8.wifikey.link":
    case "xperity9.wifikey.link": {
        instance = axios.create({
            baseURL: "https://apixperity.wifikey.link/xperity",
        });
        break;
    }
    case "xperity.roamingiqtest.com":
    case "xperity2.roamingiqtest.com":
    case "xperity3xperity.roamingiqtest.com": {
        instance = axios.create({
            baseURL: "https://apixperity.roamingiqtest.com/xperityqa",
        });
        break;
    }
    case "devgj01.wifikey.link":
    case "devgj02.wifikey.link":
    case "vault-devgj.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/devgj",
        });
        break;
    }
    case "devdd01.wifikey.link":
    case "devdd02.wifikey.link":
    case "vault-devdd.wifikey.link":
    case "localhost:3000": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/devdd",
        });
        break;
    }
    case "devsr01.wifikey.link":
    case "localhost:3003": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/devsr",
        });
        break;
    }
    case "qaapijc01.wifikey.link":
    case "qaapijc02.wifikey.link":
    case "vault-qaapijc.wifikey.link":
    case "localhost:3007": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/qaapijc",
        });
        break;
    }
    case "qauijc01.wifikey.link":
    case "qauijc02.wifikey.link":
    case "vault-qauijc.wifikey.link":
    case "localhost:5173": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/qauijc",
        });
        break;
    }
    case "qars01.wifikey.link":
    case "qars02.wifikey.link":
    case "localhost:3006": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/qars",
        });
        break;
    }
    case "qauijc02.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/devkk",
        });
        break;
    }
    case "devhk01.wifikey.link":
    case "vault-devhk.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/devhk",
        });
        break;
    }
    case "v1devpa01.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/v1devpa",
        });
        break;
    }
    case "vault-nomiso1.wifikey.link": {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/nomiso1",
        });
        break;
    }
    default: {
        instance = axios.create({
            baseURL: "https://api.wifikey.link/v1",
        });
        break;
    }
}
sessionStorage.setItem("host", host);
// baseURL: 'https://api.roamingiqtest.com/v1qa'
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;
        const refreshToken = sessionStorage.getItem("AccessToken");
        if (
            error.response &&
            error.response.status === 401 &&
            error.config &&
            !error.config.__isRetryRequest &&
            refreshToken
        ) {
            originalRequest._retry = true;
            instance
                .post("/subscriberconsole/refreshAccessToken", {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    RefreshToken: sessionStorage.getItem("RefreshToken"),
                })
                .then((tokenRefreshResponse) => {
                    //console.log("Refreshing");
                    //console.log(tokenRefreshResponse);
                    sessionStorage.setItem(
                        "AccessToken",
                        tokenRefreshResponse.data.AuthenticationResult
                            .AuthenticationResult.AccessToken
                    );
                    originalRequest.headers["Authorization"] =
                        tokenRefreshResponse.data.AuthenticationResult.AuthenticationResult.AccessToken;
                    return Promise.resolve();
                });
        }
        return Promise.reject(error);
    }
);
export default instance;
